// extracted by mini-css-extract-plugin
export default {"bottom-links__list":"tbTve","bottom-links__link":"qkN4V","bottom-links":"i3ZAR","stores":"MKkxX","stores__title":"rHJli","action-button":"Zr8UR"};